export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const firebaseTimestampToDate = (timestamp) => {
  const fireBaseTime = new Date(
    timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000,
  );
  const date = fireBaseTime.toDateString();
  const time = fireBaseTime.toLocaleTimeString();

  return `${date} ${time}`
};
